const THEME_KEY = 'user_theme_preference';

export function detectTheme() {
  const stored = localStorage.getItem(THEME_KEY);
  if (stored && (stored === 'light' || stored === 'dark')) {
    return { theme: stored, hasExplicitPref: true };
  }

  const mql = window.matchMedia('(prefers-color-scheme: dark)');
  return { theme: mql.matches ? 'dark' : 'light', hasExplicitPref: false };
}

export function saveThemePreference(theme) {
  if (theme === 'light' || theme === 'dark') {
    localStorage.setItem(THEME_KEY, theme);
  }
}

export function clearThemePreference() {
  localStorage.removeItem(THEME_KEY);
}
